:host{display:flex;flex-direction:column;width:100%}
/*# sourceMappingURL=annotation-list-section.component.css.map */
